export const ADD_TO_CART = "ADD_TO_CART";
export const REMOVIE_ITEM_CART = "REMOVIE_ITEM_CART";
export const SAVE_SHIPPING_INFO = "SAVE_SHIPPING_INFO";

export const EMPTY_CART_REQUEST = "EMPTY_CART_REQUEST";
